import React from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  Stack
} from '@mui/material';
import {
  Phone,
  Email,
  LocationOn} from '@mui/icons-material';
import TempLogo from '../../assets/svgs/temp-logo.svg.js';
import styles from '../landing/LandingPage.module.scss';

const Footer = () => {

  return (
    <Box className={styles.footer}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Grid container spacing={4} sx={{ py: 6 }} justifyContent="space-between">
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 3 }}>
              <TempLogo />
            </Box>
            <Typography variant="body1" className={styles.footerDescription} sx={{ mb: 3 }}>
              Leading healthcare data management platform dedicated to improving patient outcomes
              and operational efficiency for skilled nursing facilities.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h6" className={styles.footerSectionTitle} sx={{ mb: 3 }}>
              Contact Information
            </Typography>
            <Stack spacing={2}>
              <Box className={styles.contactItem}>
                <Phone className={styles.contactIcon} />
                <Box>
                  <Typography variant="body2" className={styles.contactLabel}>
                    Phone Support
                  </Typography>
                  <Typography variant="body1" className={styles.contactValue}>                  
                    +1 (845) 201-9691
                  </Typography>
                </Box>
              </Box>
              <Box className={styles.contactItem}>
                <Email className={styles.contactIcon} />
                <Box>
                  <Typography variant="body2" className={styles.contactLabel}>
                    Email Support
                  </Typography>
                  <Typography variant="body1" className={styles.contactValue}>
                    customersupport@simplesnf.com
                  </Typography>
                </Box>
              </Box>
              <Box className={styles.contactItem}>
                <LocationOn className={styles.contactIcon} />
                <Box>
                  <Typography variant="body2" className={styles.contactLabel}>
                    Business Hours
                  </Typography>
                  <Typography variant="body1" className={styles.contactValue}>
                    Monday - Friday: 8:00 AM - 6:00 PM EST
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Box className={styles.footerBottom}>
          <Typography variant="body2" textAlign="center">
            © 2025 SNF Data Solutions, Inc. All rights reserved. Unauthorized use or duplication is strictly prohibited.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 